export default "__VITE_ASSET__BvgOh6KH__"